import React, { useState, useEffect } from 'react';
import { holidayGroupAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { ModernSelect } from './SharedComponents';

const HolidayGroupSelector = ({ selectedGroupId, onGroupChange, showAllOption = false }) => {
  const [holidayGroups, setHolidayGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, hasPermission } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        const response = await holidayGroupAPI.getAll();
        setHolidayGroups(response.data);
      } catch (error) {
        console.error('Error fetching holiday groups:', error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <ModernSelect disabled><option>Loading holiday groups…</option></ModernSelect>;
  }

  return (
    <ModernSelect
      value={selectedGroupId || ''}
      onChange={(e) => onGroupChange(e.target.value ? parseInt(e.target.value) : null)}
      disabled={!hasPermission('can_manage_holidays') && Boolean(user?.holiday_group_id)}
    >
      <option value="">{showAllOption ? 'All groups' : 'Please select a holiday group'}</option>
      {holidayGroups.map((group) => (
        <option key={group.id} value={group.id}>
          Group {group.name}{group.description ? ` — ${group.description}` : ''}
        </option>
      ))}
    </ModernSelect>
  );
};

export default HolidayGroupSelector;
